import { useMemo } from 'react'
import { useSnapshot } from 'valtio'
import optimizeViewStore from '../../store/optimizeViewStore'

export function useOptimizeTimeRanges() {
  const snap = useSnapshot(optimizeViewStore)

  return useMemo(() => {
    const [datasetStartTime, datasetEndTime] = snap.optimizedViewRange

    return {
      datasetStartTime,
      datasetEndTime,
      productionPlanStartTime: snap.productionPlanStartTime,
      measEndTime: snap.measEndTime,
    }
  }, [snap.optimizedViewRange, snap.productionPlanStartTime, snap.measEndTime])
}
